/*
 * Decléor — Search discovery (header popdown)
 * ---------------------------------------------------------------------------
 * Sitewide companion to search-enhancements.js (which owns the search PAGE).
 * This one enhances the header predictive-search popdown:
 *   1. Recent searches: renders the last queries (shared localStorage key) as
 *      pills in the popdown's empty/discovery state. Read-only here — the term
 *      is written by search-enhancements.js when a full search is performed.
 *   2. Discovery toggle: shows the discovery panel (popular + recent pills) when
 *      the input is empty/focused, hides it as soon as the shopper types.
 *   3. Keyboard shortcut: "/" or ⌘K / Ctrl+K opens the search popdown + focuses it.
 *   4. Min-chars guard: suppresses predictive API calls for 1–2 character queries
 *      (defensive monkey-patch of the vendored <predictive-search> element).
 *
 * Driven by data-* on its own <script> tag. No-ops when its hooks aren't present.
 */
(function () {
  'use strict';

  var script = document.querySelector('script[data-search-discovery-js]');
  var SEARCH_URL = (script && script.getAttribute('data-search-url')) || '/search';
  var MIN_CHARS = parseInt((script && script.getAttribute('data-min-chars')) || '3', 10) || 3;
  var KEY = 'decleor_recent_searches';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, 6))); } catch (e) {}
  }

  /* ---------- recent-search pills (popdown only — distinct hooks from the search page) ---------- */
  function renderRecent() {
    var holders = document.querySelectorAll('[data-popdown-recent-list]');
    if (!holders.length) return;
    var items = read();
    holders.forEach(function (holder) {
      var box = holder.closest('[data-popdown-recent]');
      holder.textContent = '';
      if (!items.length) { if (box) { box.hidden = true; } return; }
      items.forEach(function (t) {
        var a = document.createElement('a');
        a.className = 'search__pill';
        a.href = SEARCH_URL + '?q=' + encodeURIComponent(t);
        a.textContent = t;
        holder.appendChild(a);
      });
      if (box) { box.hidden = false; }
    });
  }
  function wireClears() {
    document.querySelectorAll('[data-popdown-recent-clear]').forEach(function (btn) {
      if (btn.__fgWired) return;
      btn.__fgWired = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        write([]);
        renderRecent();
        // Mirror of the fix in search-enhancements.js: /search renders its own recent-searches box from
        // the same localStorage key, so clearing here has to clear that one too.
        document.querySelectorAll('[data-recent-list]').forEach(function (h) { h.textContent = ''; });
        document.querySelectorAll('[data-recent-searches]').forEach(function (b) {
          b.hidden = true;
          b.classList.add('is-hidden');
        });
      });
    });
  }

  /* ---------- discovery panel: show when the input is empty, hide while typing ---------- */
  function wireDiscovery() {
    document.querySelectorAll('[data-search-discovery]').forEach(function (panel) {
      if (panel.__fgWired) return;
      panel.__fgWired = true;
      var scope = panel.closest('[data-popdown-outer]') || panel.closest('form') || document;
      var input = scope.querySelector('[data-predictive-search-input], input[type="search"]');
      if (!input) return;
      var sync = function () {
        var empty = !input.value || input.value.trim() === '';
        panel.hidden = !empty;
      };
      input.addEventListener('input', sync);
      input.addEventListener('focus', sync);
      sync();
    });
  }

  /* ---------- keyboard shortcut: "/" or ⌘K / Ctrl+K opens + focuses the search popdown ---------- */
  function wireShortcut() {
    document.addEventListener('keydown', function (e) {
      var t = e.target;
      var tag = (t && t.tagName) || '';
      var typing = /^(INPUT|TEXTAREA|SELECT)$/.test(tag) || (t && t.isContentEditable);
      var slash = e.key === '/' && !typing && !e.metaKey && !e.ctrlKey && !e.altKey;
      var cmdk = (e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey);
      if (!slash && !cmdk) return;
      var toggle = document.querySelector('[data-popdown-toggle="search-popdown"]');
      if (!toggle) return;
      e.preventDefault();
      toggle.click();
      setTimeout(function () {
        var i = document.querySelector('#search-popdown [data-predictive-search-input], #search-popdown input[type="search"]');
        if (i) { i.focus(); }
      }, 80);
    });
  }

  /* ---------- min-chars guard for the vendored <predictive-search> element ----------
     Defensive: only patches if the method exists, only skips on 1–2 char terms, and
     falls through to the original on any uncertainty — so search never breaks. */
  function patchMinChar() {
    if (!('customElements' in window) || !window.customElements.whenDefined) return;
    customElements.whenDefined('predictive-search').then(function () {
      var PS = customElements.get('predictive-search');
      if (!PS || !PS.prototype || PS.prototype.__fgMinChar) return;
      if (typeof PS.prototype.getSearchResults !== 'function') return;
      var orig = PS.prototype.getSearchResults;
      PS.prototype.getSearchResults = function () {
        try {
          var input = this.querySelector('input[type="search"], [data-predictive-search-input]');
          var term = input && input.value ? input.value.trim() : null;
          if (term !== null && term.length > 0 && term.length < MIN_CHARS) { return; }
        } catch (e) {}
        return orig.apply(this, arguments);
      };
      PS.prototype.__fgMinChar = true;
    }).catch(function () {});
  }

  function init() {
    renderRecent();
    wireClears();
    wireDiscovery();
    wireShortcut();
    patchMinChar();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme-editor section reloads re-inject the header popdown.
  document.addEventListener('shopify:section:load', function () { renderRecent(); wireClears(); wireDiscovery(); });
})();
